export default __webpack_public_path__ + "static/media/diamondShape.467470c6.svg";